export default __webpack_public_path__ + "media/pipes.cbcf0318.png";